import React, { Component } from 'react';

import AirDrawer from '../../../../common/components/AirDrawer';

import './CarAdvancedFilter.css';
import { inject, observer } from 'mobx-react';
import MakeModelFilter from './filters/MakeModelFilter';
import AlimentationFilter from './filters/AlimentationFilter';
import TotalKmFilter from './filters/TotalKmFilter';
import RegistrationYearFilter from './filters/RegistrationYearFilter';

@inject('translationsStore', 'carsStore')
@observer
export default class CarAdvancedFilter extends Component {
  constructor(props) {
    super(props);

    this.state = { visible: this.props.visible };

    this.AlimentationFilterRef = React.createRef();
    this.TotalKmFilterRef = React.createRef();
    this.RegistrationYearFilterRef = React.createRef();
  }

  componentDidMount() {
    if (this.props.cars) {
      this.init(this.props.cars);
    }
  }

  componentWillUnmount() {
    this.props.carsStore.resetFilters();
  }

  componentDidUpdate(prevProps) {
    if (this.props.cars && this.props.cars !== prevProps.cars) {
      this.init(this.props.cars);
    }
  }

  init(cars) {
    this.setState({ cars });
  }

  hide = () => {
    this.setState({ visible: false });
  };

  show = () => {
    this.setState({ visible: true });
  };

  reset = () => {
    this.props.carsStore.resetFilters();
  };

  apply = () => {
    this.props.carsStore.applyFilters();
    this.hide();
  };

  render() {
    const { translationsStore, carsStore } = this.props;
    const { visible } = this.state;

    return (
      <AirDrawer
        width="570px"
        className="CarAdvancedFilter"
        visible={visible}
        onClose={this.hide.bind(this)}
        title={translationsStore.translate('advancedfilter.title')}
        okLabel={translationsStore.translate('advancedfilter.button.apply')}
        cancelLabel={translationsStore.translate('advancedfilter.button.reset')}
        onOk={this.apply}
        onCancel={this.reset}
        disabled={false}
      >
        <MakeModelFilter status={carsStore.appliedFilters.models !== undefined} />
        <AlimentationFilter ref={this.AlimentationFilterRef} status={carsStore.appliedFilters.alimentation !== undefined} />
        <TotalKmFilter ref={this.TotalKmFilterRef} status={carsStore.appliedFilters.totalKmMin !== undefined} />
        <RegistrationYearFilter ref={this.RegistrationYearFilterRef} status={carsStore.appliedFilters.registrationYearMin !== undefined} />
      </AirDrawer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/CarAdvancedFilter/CarAdvancedFilter.js